import CaliforniaUniversityImage from "../../../assets/university_logos/University of California, Berkeley.png";
import MITUniversityImage from "../../../assets/university_logos/Massachusetts Institute of Technology (MIT).png";
import SanfordUniversityImage from "../../../assets/university_logos/Stanford University.png";
import CaltechUniversityImage from "../../../assets/university_logos/caltechUniversity.png";

export const UsaBestUniversities = [
  {
    name: "University of California",
    logo: CaliforniaUniversityImage,
    country: "Excellence in research and education.",
  },
  {
    name: "Sandford University",
    logo: SanfordUniversityImage,
    country: "Engineering, Business, Computer Science",
  },
  {
    name: "MIT",
    logo: MITUniversityImage,
    country: "MIT is renowned for innovation and excellence.",
  },
  {
    name: "Caltech",
    logo: CaltechUniversityImage,
    country: "Caltech excels in science, engineering, innovation.",
  },
];
